
  import Vue from 'vue'
  import FilterChipTemplate from './FilterChipTemplate.vue';
  import { autoComplete } from '@/utils/Util';
import UserService from '@/services/UserService';

  export default Vue.extend({
    name: 'UserFilter',

    components: {
      FilterChipTemplate
    },
    props: ['value', 'label', 'attributes', 'mandatory', 'always', 'small'],
    data: (_this: any): any => ({
      rules: [
          (v: any) => !!v || _this.requiredError
      ],
      localUser: _this.value[_this.attributes['value']],
      localFilters: _this.value as any,
      menu: false,
      loading: false,
      users: [],
    }),
    created() {
      this.getUsers();
    },
    methods: {
      onSave() {
        this.localFilters[this.attributes['value']] = this.localUser;
        this.$emit('input', { ...this.localFilters });
        this.menu = false;
      },
      onReset() {
        this.$delete(this.localFilters, this.attributes['value']);
        this.$emit('input', { ...this.localFilters });
        this.menu = false;
      },
      onChipRemove() {
        this.$delete(this.localFilters, this.attributes['value']);
        this.$emit('input', { ...this.localFilters });
        this.$emit('delete');
      },
      autoComplete,
      getUsers() {
        this.users = [];
        this.loading = true;
        
        UserService.getAllCollectionPages({ tenant: this.currentTenant }).then((users: any[]) => {
            this.loading = false;

            this.users = users;
        }).catch((err: any) => {
            console.log(err, err.response); 
            this.loading = false;     
        });
      },
    },
    watch: {
      value() {
        this.localFilters = { ...this.value };
        this.localUser = this.localFilters[this.attributes['value']];
      },
      menu() {
        if(!this.menu) {
          this.localUser = this.localFilters[this.attributes['value']];
        }
      },
      currentTenant() {
        this.users = [];
        this.localFilters = { ...this.value }; // TODO
        this.getUsers();
      }
    },
    computed: {
      filterRepr(): any {
        const raw = this.localFilters[this.attributes['value']];
        if (!raw) return '';
        const found = this.users.find((u: any) => u.uuid === raw);
        return found ? found.email : raw;
      },
      isValid(): any {
        return this.mandatory ? this.rules.reduce((acc: boolean, rule: any) => acc ? rule(this.localUser)===true : acc, true) : true;
      },
      requiredError(): any {
        return this.$t('required');
      },
      currentTenant(): any {
        return this.$root.$store.state.session.selectedTenant.uuid;
      },
    }
  })
